import { Component, effect, EventEmitter, inject, Input, OnChanges, OnDestroy, Output, signal, SimpleChanges, ViewChild } from '@angular/core';
import { Accordion, AccordionTabCloseEvent } from 'primeng/accordion';
import { GridComponent } from 'src/app/shared/components/grid/grid.component';
import { ModelLibraryCollection } from 'src/app/shared/models/model-library';
import { SetupLogicService } from 'src/app/shared/services/setup.logic.service';
import { RowDragEvent, RowNode } from 'ag-grid-community';

@Component({
  selector: 'app-ef-setup-models-to-be-run',
  templateUrl: './ef-setup-models-to-be-run.component.html',
  styleUrls: ['./ef-setup-models-to-be-run.component.css']
})
export class EFSetupModelsToBeRunComponent implements OnChanges, OnDestroy {

  @ViewChild('accordion') accordion!: Accordion;
  @ViewChild('grid') grid!: GridComponent;
  @Input() modelsToBeRun: any[] = [];
  @Input() columnsDefinition: any = [];
  @Input() modelsLoading: boolean = false;
  @Input() isProjectOwnershipValid: boolean = true;
  @Input() modelsCollection: ModelLibraryCollection[] = [];
  
  @Output() orderedModelsToBeRunRowData = new EventEmitter();
  @Output() selectedMoleculesChanged = new EventEmitter<Array<{ moleculePk: number, activeIngredientName: string, concentration: string, unit: string, mainActive: boolean, aeConcentration: string }>>();

  gridStyle: string = 'width: min(100%, 640px); height: 420px; text-align: left; z-index:-1;font-size:10px; color: #656565;';
  rowHeight: number = 120;
  selected = false;
  activeIndex: number | null = null;
  isValid: boolean = true;
  public showModels: boolean = false;

  selectedMoleculeToBeRun = signal<Array<{ moleculePk: number, activeIngredientName: string, concentration: string, unit: string, mainActive: boolean, aeConcentration: string }>>([]);

  private setupLogicService = inject(SetupLogicService);
  
  selectedGeographyEffect = effect(() => {
    this.showModels = this.setupLogicService.selectedGeographyKey() !== undefined;
  });

  public getSelectedMolecules(): Array<{ moleculePk: number, activeIngredientName: string, concentration: string, unit: string, mainActive: boolean, aeConcentration: string }> {
    const selectedMolecules = this.modelsToBeRun
      .filter((model: any) => model.selected === true)
      .map((model: any) => ({
        moleculePk: model.activeIngredient.moleculePk,
        activeIngredientName: model.activeIngredient.moleculeName,
        concentration: model.activeIngredient.concentration ?? '',
        unit: model.activeIngredient.unit ?? '',
        mainActive: model.activeIngredient.mainActive ?? false,
        aeConcentration: model.activeIngredient.aeConcentration ?? ''
      }));
    return selectedMolecules;
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['modelsToBeRun']) {
      this.activeIndex = null;
      this.updateSelectedMolecules();
      this.validateSelectedModels();
    }
  }

  private updateSelectedMolecules(): void {
    const selectedMolecules = this.getSelectedMolecules();
    if (selectedMolecules) {
      this.selectedMoleculeToBeRun.set(selectedMolecules);
      this.selectedMoleculesChanged.emit(selectedMolecules);
    }
  }

  onClose(event: AccordionTabCloseEvent) {
    this.activeIndex = null;
  }

  onOpen({ index, originalEvent }: AccordionTabCloseEvent) {
    if (!this.modelsToBeRun[index].selected) {
      originalEvent.stopPropagation();
      const tab = this.accordion.tabs.find(t => t.findTabIndex() == index);
      if (tab) tab.selected = false;
      this.activeIndex = null;
      return;
    }
    this.activeIndex = index;
  }

  modelsListBoxSelectionChanged({ data, selectedValues, compartment }: any) {
    data[compartment] = selectedValues;
    this.setCompoundOrder();
    this.validateSelectedModels();
    this.updateSelectedMolecules();
    this.grid.gridApi.redrawRows();
  }

  validateSelectedModels() {
    this.isValid = false;
    this.modelsToBeRun.map(model => {
      model.rowData.map((row: any) => {
        this.modelsCollection.map(modelCol => {
          if (row[modelCol.name]?.length > 0) this.isValid = true;
        });
      });
    });
  }

  ngOnDestroy(): void {
    this.selectedGeographyEffect.destroy();
  }

  onRowDragEnd(event: RowDragEvent) {
    this.setCompoundOrder();
    this.orderedModelsToBeRunRowData.emit();
  }

  setCompoundOrder() {
    let cont = 1;
    this.grid.gridApi.forEachNode((node: RowNode) => {
      node.data.compoundOrder = cont;
      cont++;
    });
  }
}
